__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "web-seller-container-mf";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "1.6.5", () => (() => (__webpack_require__(1744))), 1);
			register("moment", "2.30.1", () => (__webpack_require__.e(426).then(() => (() => (__webpack_require__(2426))))));
			register("native-base", "3.4.28", () => (() => (__webpack_require__(6919))), 1);
			register("normalize-css-color", "1.0.2", () => (() => (__webpack_require__(4197))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(4164))), 1);
			register("react-error-boundary", "4.0.12", () => (__webpack_require__.e(2).then(() => (() => (__webpack_require__(3002))))));
			register("react-gtm-ts", "1.0.45", () => (__webpack_require__.e(817).then(() => (() => (__webpack_require__(4817))))));
			register("react-idle-timer", "5.7.2", () => (__webpack_require__.e(239).then(() => (() => (__webpack_require__(3239))))));
			register("react-native-safe-area-context", "4.8.2", () => (() => (__webpack_require__(9350))), 1);
			register("react-native", "0.19.10", () => (() => (__webpack_require__(4278))));
			register("react-router-dom", "6.21.1", () => (__webpack_require__.e(276).then(() => (() => (__webpack_require__(6276))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(2791))), 1);
			initExternal(9712);
			initExternal(8654);
			initExternal(2244);
			initExternal(8508);
			initExternal(6083);
			initExternal(2941);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};